import {inject} from '@angular/core';
import {ConfigService} from './config.service';

export function configInitializer() {
  const configService = inject(ConfigService);

  return new Promise((resolve, _reject) => {
    setTimeout(() => {
      configService.setup();
      resolve('Setup complete');
    });
  });
}
